import { Component, inject } from '@angular/core';
import { MagicSearchService } from '../../../creators/service/magic-search/magic-search.service';
import { CreatorCardPinkComponent } from '../creator-card-pink/creator-card-pink.component';
import { NgxFlickeringGridComponent } from '@omnedia/ngx-flickering-grid';
import { NgxOrbComponent } from '@omnedia/ngx-orb';
import { NgxTypewriterComponent } from '@omnedia/ngx-typewriter';
import { CreatorCardBlueComponent } from '../../../creators/molecules/creator-card-blue/creator-card-blue.component';
import { CreatorCardPurpleComponent } from '../creator-card-purple/creator-card-purple.component';

@Component({
  selector: 'cv2-searched-creators',
  standalone: true,
  imports: [CreatorCardPinkComponent, CreatorCardBlueComponent, CreatorCardPurpleComponent,
    NgxFlickeringGridComponent, NgxOrbComponent, NgxTypewriterComponent],
  templateUrl: './searched-creators.component.html',
  styleUrl: './searched-creators.component.css'
})
export class SearchedCreatorsComponent {

  /** Services */
  public magicSearchService = inject(MagicSearchService);
  /** Services - END */
}
